<template>
  <div>
    <FAIcon v-if="statusInfo.processing" icon="fa fa-spin fa-spinner" />
    {{ isAdmin ? statusInfo.descriptionAdmin : statusInfo.descriptionUser }}
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import { AuthenticateGetter } from "@/store/modules/AuthenticateStore.js"
import { apiGetDocumentStateByStateId } from "@/services/document_management_service.js"
import FAIcon from "@/components/common/FAIcon.vue"

export default {
  name: "DocumentStatus",
  components: { FAIcon },
  props: {
    status: {
      type: String,
      default: null,
    },
  },
  computed: {
    statusInfo() {
      return apiGetDocumentStateByStateId(this.status)
    },
    ...mapGetters({
      isAdmin: AuthenticateGetter.IS_ADMIN,
    }),
  },
}
</script>

<style scoped></style>
